import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import actions from 'redux/actions'

import InsideLayout from 'layouts/InsideLayout/InsideLayout'
import { WidthContainer } from 'components/_new/layout/widthContainer'
import MainSection from 'components/_new/layout/MainSection/MainSection'

import AddPerfumeToQueueCountdown from './AddPerfumeToQueueCountdown/AddPerfumeToQueueCountdown'
import ThankYouForOrder from './ThankYouForOrder/ThankYouForOrder'
import AddToQueueButton from './AddToQueueButton/AddToQueueButton'
import UpgradePlans from './UpgradePlans/UpgradePlans'
import InviteLink from './InviteLink/InviteLink'
import Orders from './Orders/Orders'
import Title from './Title/Title'


export default class ThankYouPageContent extends Component {

  static propTypes = {
    gender: PropTypes.oneOf([ 'male', 'female' ]),
    data: PropTypes.object,
    billingPeriod: PropTypes.number,
    hasItemInQueue: PropTypes.bool,
    isSubscription: PropTypes.bool,
    redirectLink: PropTypes.string,
    isUpgradable: PropTypes.bool,
  }

  componentDidMount() {
    const { hasItemInQueue } = this.props

    if (!hasItemInQueue) {
      this.bindEventListener()
    }
  }

  componentWillUnmount() {
    this.unbindEventListener()
  }

  bindEventListener = () => {
    const { data: { paymentType } } = this.props

    if (paymentType === constants.paymentTypes.subscription) {
      document.addEventListener('mouseleave', this.openThankYouQueueModal)
    }
  }

  unbindEventListener = () => {
    document.removeEventListener('mouseleave', this.openThankYouQueueModal)
  }

  openThankYouQueueModal = () => {
    const { redirectLink } = this.props

    actions.models.modals.open(constants.modals.ThankYouQueue, { redirectLink })
    this.unbindEventListener()
  }

  render() {
    const { billingPeriod, gender, hasItemInQueue, redirectLink, data, isSubscription, isUpgradable } = this.props
    const { ecommerceOrderNumber, subscriptionOrderNumber, isEcommerceErrorExist } = data

    const isNeedToAddItemToQueue = isSubscription && !hasItemInQueue
    const isUpgradeSectionVisible = isUpgradable && isSubscription

    return (
      <InsideLayout withSubHeader>
        <WidthContainer>
          <MainSection alignCenter>
            <Title {...data} />
            {
              isNeedToAddItemToQueue ? (
                <AddPerfumeToQueueCountdown gender={gender} />
              ) : (
                <ThankYouForOrder gender={gender} />
              )
            }
            <AddToQueueButton gender={gender} link={redirectLink} />
            {
              isUpgradeSectionVisible && (
                <UpgradePlans />
              )
            }
            {
              billingPeriod && (
                <Orders {...{ isEcommerceErrorExist, ecommerceOrderNumber, subscriptionOrderNumber, billingPeriod }} />
              )
            }
            {
              isSubscription && (
                <InviteLink gender={gender} dataTestId={constants.testIds.thankYouPage.bottomInviteLink} />
              )
            }
          </MainSection>
        </WidthContainer>
      </InsideLayout>
    )
  }
}
